// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-body[data-v-1e13af53]{background:#f5fbff}.main-text[data-v-1e13af53]{color:var(--lms-tenant)}.text-grey[data-v-1e13af53]{color:#5c5c5c}.negative-top[data-v-1e13af53]{margin-top:-.5em}", ""]);
// Exports
module.exports = exports;
